import type { CatalogMeta } from "../types";

export const catalogMeta: CatalogMeta = {
  lastUpdated: "2026-09-19",
  disclaimer:
    "Prices are researched from public official documentation and host listings. They change frequently. Always verify on the provider's pricing page before budgeting. Entries marked estimated/unknown are not inventing numbers — treat them as leads, not quotes. Community caveats use Reddit sampling + Jev and are not scientific benchmarks.",
};
